import { useGetFeatureFlagsQuery } from 'src/services/dashboard-api';

export default function useIsProactiveConversationsEnabled() {
  const { data: featureFlagsData } = useGetFeatureFlagsQuery();
  const { feature_flags: featureFlags = [] } = featureFlagsData ?? {};

  return featureFlags.includes('proactive_conversations');
}
